import { useParams } from 'react-router-dom';

import { useAppSelector } from 'app/hooks';
import { PalmDataGrid } from 'common/components/PalmDataGrid';
import { Roles } from 'common/constants/roles';
import { usePalmButtonEvaluator } from 'common/hooks/usePalmButtonEvaluator';
import { usePalmFetchEntitiesWithExtraReducers } from 'common/hooks/usePalmFetchEntitiesWithExtraReducers';
import { usePalmFilters } from 'common/hooks/usePalmFilters';
import { usePalmSortModel } from 'common/hooks/usePalmSortModel';
import { fetchAclAccesses } from 'common/services/api/Acls/AclAccesses.thunk';
import {
    ColumnDefinition,
    ColumnType,
    Operations } from 'common/types/TypeDefs';

import { selectEntities, selectProcessing } from '../aclAccesses/aclAccessesSlice';

import { AclAccessDeleteDialogContent } from './AclAccessDeleteDialogContent';
import { AclAccessesEditContent } from './AclAccessesEditDrawerContent';
import {
    addNewFilter,
    clearEntities,
    clearFilters,
    removeFilter,
    selectError,
    selectFilters } from './aclAccessesSlice';

export const AclAccessesTab = () => {

    const typeName = 'ACL Access';
    const shouldDisableButtons = usePalmButtonEvaluator([ Roles.Admin, Roles.AppManager ]);
    const [sortModel, setSortModel] = usePalmSortModel();

    const filterProp = usePalmFilters(
        selectFilters,
        addNewFilter,
        removeFilter,
        clearFilters);

    const params = useParams();
    const fetchEntities = usePalmFetchEntitiesWithExtraReducers(
        typeName,
        selectEntities,
        selectError,
        clearEntities,
        fetchAclAccesses,
        { tenantId: params.tenantId ?? '' });

    const processing = useAppSelector(selectProcessing);

    const actionDefinitions =  [
        { action: Operations.Edit, disabled: shouldDisableButtons },
        { action: Operations.Delete, disabled: shouldDisableButtons }
    ];

    const columnDefinitions: ColumnDefinition[] = [
        { columnId: 'id', columnName: 'ACL Access ID', columnType: ColumnType.First, shouldFilterByExactMatch: true },
        { columnId: 'name', columnName: 'Access Name', columnType: ColumnType.Tooltip },
        { columnId: 'actions', columnName: 'Action', columnType: ColumnType.Action }
    ];

    return <PalmDataGrid
        title={typeName}
        actionDefinitions={actionDefinitions}
        columnDefinitions={columnDefinitions}
        deleteFunction={AclAccessDeleteDialogContent}
        contentFunction={AclAccessesEditContent}
        isCreateButtonDisabled={shouldDisableButtons}
        processing={processing}
        filter={filterProp}
        refreshDataGridClick={() => fetchEntities()}
        sortModel={sortModel}
        clientSortHandler={setSortModel}
        shouldShowExportButton={true}
    />;
};
